<template>

</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'Frill',
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
  },
  async created() {
    (function (t, r) {
      function s() {
        var a = r.getElementsByTagName('script')[0], e = r.createElement('script');
        e.type = 'text/javascript', e.async = !0, e.src = 'https://widget.frill.co/v2/container.js', a.parentNode.insertBefore(e, a)
      }

      if (!t.Frill) {
        var o = 0, i = {};
        t.Frill = function (e, p) {
          var n, l = o++, c = new Promise(function (v, d) {
            i[l] = {
              params: [e, p], resolve: function (f) {
                n = f, v(f)
              }, reject: d
            }
          });
          return c.destroy = function () {
            delete i[l], n && n.destroy()
          }, c
        }, t.Frill.q = i;
      }
      r.readyState === 'complete' || r.readyState === 'interactive' ? s() : r.addEventListener('DOMContentLoaded', s)
    })(window, document);

    // Wait for Frill script to load
    await new Promise((resolve) => {
      const checkFrill = setInterval(() => {
        if (window.Frill && window.Frill.q) {
          clearInterval(checkFrill);
          resolve();
        }
      }, 50);

      // Timeout after 5 seconds
      setTimeout(() => {
        clearInterval(checkFrill);
        resolve();
      }, 5000);
    });

    try {
      await window.Frill('container', {
        key: 'container_ZoDeyc_OjTbIw',
      });

      // Container is ready, mark as ready and try to identify
      this.frillReady = true;
      
      // Try to identify immediately after container is ready
      this.identifyUser();

      window.FrillWidget = await window.Frill('widget', {
        key: 'widget_e45cwI_ZV4DXb',
      });

      window.FrillIdeaWidget = await window.Frill('widget', {
        key: 'widget_jn5N3b_WRxsUZ',
      });

      // window.FrillWidget.events.on('badgeCount', this.handleSetAnnouncementCount);

      this.setupFrillSurveyListener();
    } catch (error) {
      console.error('Frill initialization error:', error);
    }
  },
  beforeUnmount() {
    // window.FrillWidget.events.off('badgeCount', this.handleSetAnnouncementCount);
    
    // Remove message listener
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
    }
    
    // Restore original fetch if we intercepted it
    if (this.originalFetch) {
      window.fetch = this.originalFetch;
    }
  },
  data() {
    return {
      identified: false,
      frillReady: false,
      originalFetch: null,
      messageHandler: null,
    };
  },
  methods: {
    ...mapActions({
      // setAnnouncementCount: 'system/setAnnouncementCount',
    }),
    handleSetAnnouncementCount(event) {
      // this.setAnnouncementCount(event.count);
    },
    setupFrillSurveyListener() {
      const self = this;

      // Listen for postMessage events from Frill iframe
      const messageHandler = (event) => {
        // Check if message is from Frill domain
        if (event.origin !== 'https://widget.frill.co' && event.origin !== 'https://frill.co') {
          return;
        }

        // Check if it's a Frill survey submission with score 4 or 5
        if (event.data && typeof event.data === 'object') {
          const data = event.data;
          
          // Frill sends: { type: "FRILL", message: { name: "onSubmit", params: [{ score: 4 or 5, ... }] } }
          if (data.type === 'FRILL' && 
              data.message?.name === 'onSubmit') {
            const score = data.message?.params?.[0]?.score;
            if (score === 4 || score === 5) {
              self.handleHighRatingSurvey(score);
            }
          }
        }
      };

      window.addEventListener('message', messageHandler);
      this.messageHandler = messageHandler;

      // Also try to intercept fetch on parent window (in case Frill doesn't use iframe for surveys)
      if (!this.originalFetch) {
        this.originalFetch = window.fetch;
      }

      window.fetch = function(...args) {
        const [url, options = {}] = args;

        // Check if this is a Frill GraphQL request
        if (typeof url === 'string' && url.includes('widget.frill.co/graphql') && options.method === 'POST') {
          if (options.body) {
            try {
              const body = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
              
              if (body.operationName === 'SubmitSurvey' && 
                  body.variables?.input?.is_completed === true) {
                const score = body.variables?.input?.score;
                if (score === 4 || score === 5) {
                  setTimeout(() => {
                    self.handleHighRatingSurvey(score);
                  }, 500);
                }
              }
            } catch (e) {
              console.error('Error parsing Frill request body:', e);
            }
          }
        }

        return self.originalFetch.apply(this, args);
      };
    },
    async handleHighRatingSurvey(score) {
      // Send survey response to backend for email processing
      try {
        const token = await window.app.auth.getToken();
        const apiBaseUrl = window.app.env.apiBaseUrl || '';
        
        await fetch(`${apiBaseUrl}/survey/submit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : '',
          },
          body: JSON.stringify({
            score: score,
          }),
        });
      } catch (error) {
        console.error('Error submitting survey response:', error);
      }
    },
    async identifyUser() {
      if (import.meta.env.VITE_APP_ENV === 'local' || !window.Frill || !this.user || this.identified || !this.frillReady) {
        if (import.meta.env.VITE_APP_ENV === 'local') {
          console.log('Frill identify skipped - local env');
        } else if (!window.Frill) {
          console.log('Frill identify skipped - Frill not available');
        } else if (!this.user) {
          console.log('Frill identify skipped - no user');
        } else if (this.identified) {
          console.log('Frill identify skipped - already identified');
        } else if (!this.frillReady) {
          console.log('Frill identify skipped - not ready');
        }
        return;
      }

      const attributes = {
        id: this.user.id,
      };

      if (this.user.createdAt) {
        const createdDate = new Date(this.user.createdAt);
        if (!isNaN(createdDate.getTime())) {
          attributes.created = createdDate.toISOString();
        }
      }

      try {
        console.log('Calling Frill identify with:', {
          email: this.user.email,
          name: this.user.fullName,
          attributes,
        });
        
        await window.Frill('identify', {
          email: this.user.email,
          name: this.user.fullName,
          attributes,
        });
        
        console.log('Frill identify successful');
        this.identified = true;
      } catch (error) {
        console.error('Frill identify error:', error);
      }
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.identifyUser();
      },
    },
    frillReady: {
      handler(newVal) {
        if (newVal) {
          this.identifyUser();
        }
      },
    },
  }
};
</script>

<style scoped lang="scss">

</style>
